import { Component, OnInit, Input } from '@angular/core';
import { Breadcrumb } from 'src/app/shared/interfaces/Organization';
import { Location } from '@angular/common';
import { Alert } from 'src/app/shared/models/alert.model';
import { SieniService } from 'src/app/shared/services/sieni.service';
import { GlobalsService } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { IdToolboxAM, IdToolboxMAIL } from '../../models/toolbox.model';

@Component({
  selector: 'breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.sass'],
})
export class BreadcrumbsComponent implements OnInit {
  constructor(
    private _location: Location,
    private translate: TranslateService,
    private _globalService: GlobalsService,
    private _sieniService: SieniService
  ) {}

  @Input() public back: boolean = false;
  @Input() public crumbs: Breadcrumb[];
  @Input() public hash: string = null;

  public sending: boolean = false;

  ngOnInit() {}

  public return() {
    this._location.back();
  }

  public openMail() {
    this.sending = true;
    const currentUser = this._globalService.user;
    const currentOrganizacion = this._globalService.organizacion;
    if (!!currentOrganizacion && !!currentUser) {
      this.sending = false;
      const toolboxMail = currentOrganizacion.toolboxes.find(
        (item) => item.id == IdToolboxMAIL
      );
      const json: any = JSON.stringify({
        user: currentUser,
        organization: currentOrganizacion,
      });
      const token = btoa(unescape(encodeURIComponent(json)));
      var win = window.open(
        toolboxMail.url + '?toolbox=' + IdToolboxAM + '&code=' + token
      );
    } else {
      this.sending = false;
      Alert.buildErrorAlert(
        this.translate.instant('breadCrumbs.alert.error-mail')
      );
    }
  }

  public openHelp() {
    this.sending = true;
    if (!this.hash) {
      this.hash = window.location.pathname.replace('/am/', '');
      console.warn('Ruta sugerida para la ayuda: ', this.hash);
    }
    if (this.hash) {
      this._sieniService.getHelp(this.hash).subscribe(
        (res: any) => {
          // console.log(res)
          this.sending = false;
          var win = window.open(
            res.data.url,
            'Title',
            'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=200,top=' +
              (screen.height - 400) +
              ',left=' +
              (screen.width - 840)
          );
          // var win = window.open(res.data.url, "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=200,top="+(screen.height-400)+",left="+(screen.width-840));
        },
        (error) => {
          this.sending = false;
          console.log(error);
          Alert.buildErrorAlert(
            this.translate.instant('breadCrumbs.alert.error-help')
          );
        }
      );
    }
  }
}
